import { PrimaryColor } from '@carecircle/core';
import { makeStyles } from 'tss-react/mui';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) => ({
  progress: {
    color: PrimaryColor,
  },
  fullScreen: {
    width: '100%',
    height: 'calc(var(--vh, 1vh) * 100 - 84px)',
  },
  logoExtended: {
    width: '100%',
    height: '100vh',
  },
}));
